import { mapActions } from 'vuex'
export default {
  computed: {
    stateResult: {
      get () {
        return this.capability.result
      },

      set (value) {
        this.setCapabilityResult({ property: 'result', value, id: this.capability.id })
      }
    }
  },

  methods: {
    ...mapActions('placements/capabilities', ['setCapabilityResult'])
  }
}
